import styled from '@emotion/styled';
import { FONT, SPACING, MEDIA_QUERY, ZINDEX } from '../../styles/emotion';
import COLORS, { COLORS_SEMANTIC } from '../../styles/emotion/colors3';
import { LinkV2 } from '../LinkV2';

const animationDuration = '0.4s';

export const ToastV2Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};

  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}

  color: ${COLORS.WHITE_100};
  padding: ${SPACING.MD};
  border-radius: 4px;
  max-width: 600px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.12);

  /* animations/helpers */
  transition: opacity ${animationDuration} ease-in-out, margin-top ${animationDuration};
  filter: progid:dximagetransform.microsoft.alpha(Opacity=100);
  margin: 0 auto;
  z-index: ${ZINDEX.super + 1};

  &--positive,
  &--message {
    background-color: ${COLORS_SEMANTIC.POSITIVE_100};
  }

  &--negative {
    background-color: ${COLORS_SEMANTIC.NEGATIVE_100};
  }

  &--informational {
    background-color: ${COLORS_SEMANTIC.INFORMATIONAL_100};
  }

  & > .zui-toast__icon {
    display: none;

    ${MEDIA_QUERY.NOT_MOBILE} {
      height: 24px;
      width: 16px;
      margin-right: ${SPACING.XS};
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }
  }

  _:-ms-fullscreen,
  :root .zui-toast__content,
  :root .zui-toast__headline {
    // to support IE11
    width: 100%;
  }

  // Helps animating slideUp with multiple toasts
  &:first-child {
    margin-top: -${SPACING.LG};
  }

  & + & {
    margin-top: ${SPACING.SM};
  }

  // CSSTransition classes
  &-enter {
    opacity: 0;
  }

  &-enter-active {
    opacity: 1;
  }

  &-zola-exit {
    opacity: 1;
  }

  &-exit-active {
    opacity: 0;
    transition: all ${animationDuration} ease-in-out;
    z-index: ${ZINDEX.super + 1};
    filter: progid:dximagetransform.microsoft.alpha(Opacity=100);
  }

  & > .addedToRegistryToast {
    .registryCta {
      color: ${COLORS.WHITE_100};
      margin-left: 64px;

      ${MEDIA_QUERY.MOBILE} {
        margin-left: ${SPACING.MD};
      }

      &:hover {
        color: ${COLORS.WHITE_100};
      }
    }
  }
`;

export const Content = styled.div`
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Dek = styled.div`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALLER)}
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
`;

export const DismissLink = styled(LinkV2)`
  margin-left: ${SPACING.LG};
  align-self: center;
`;

export const NormalLink = styled(LinkV2)`
  margin-left: ${SPACING.LG};
  align-self: center;
`;
